export const getIconUrl = name => `/${__STATIC_DIRECTORY__}/img/${name}`;

export const getCountryIconUrl = code => `https://cdn.nur.kz/static/countries/${code?.toLowerCase()}.svg`;

export const fetchData = ({domain = window.Site?.sportDomain, url}) => {
  if (!domain) {
    return Promise.reject('Euro 2020: empty domain');
  }

  return fetch(`${domain}${url}`, {headers: {'Content-Type': 'application/json'}})
    .then(response => (
      response.ok
        ? response.json()
        : Promise.reject(`Euro 2020: API response status – ${response.status}`)
    ));
};

export const enableScroll = () => {
  const scrollY = document.body.style.top;

  document.body.style.position = '';
  document.body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
};

export const disableScroll = () => {
  document.body.style.top = `-${window.scrollY}px`;
  document.body.style.position = 'fixed';
};
